import { fontList } from '../../core/font-list';
import { colorListPairs } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '1920 x 1080',
        'value': [1920, 1080],
        'label': '1920 x 1080'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1920 x 1080',
          'value': [1920, 1080],
          'label': '1920 x 1080'
        },
        {
          'key': '1600 x 900',
          'value': [1600, 900],
          'label': '1600 x 900'
        },
        {
          'key': '1280 x 720',
          'value': [1280, 720],
          'label': '1280 x 720'
        },
        {
          'key': '960 x 540',
          'value': [960, 540],
          'label': '960 x 540'
        },
        {
          'key': '640 x 360',
          'value': [640, 360],
          'label': '640 x 360'
        },
        {
          'key': '320 x 180',
          'value': [320, 180],
          'label': '320 x 180'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting visualisatie',
    },
    'animationType': {
      'default': {
        'key': 'slideIn',
        'value': 'slideIn',
        'label': 'Schuif in'
      },
      'label': 'Animatie',
      'type': 'string',
      'values': [
        {
          'key': 'bounce',
          'value': 'bounce',
          'label': 'Stuiter'
        },
        {
          'key': 'zoom',
          'value': 'zoom',
          'label': 'Zoom'
        },
        {
          'key': 'slideIn',
          'value': 'slideIn',
          'label': 'Schuif in'
        },
        {
          'key': 'slideOut',
          'value': 'slideOut',
          'label': 'Schuif uit'
        },
      ],
      'control': 'standard-select',
      'description': 'Animatie van de circel',
    },
    'width': {
      'default': 1920,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 1080,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'colorScheme': {
      'default': colorListPairs[2],
      'control': 'cbs-color-scheme',
    },
    'circleColorScheme': {
      'default': colorListPairs[1],
      'control': 'cbs-color-scheme',
      'description': 'Kleur van de circel',
    },
    'offsetX': {
      'default': 420,
      'label': 'Afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand t.o.v. de linkerkant',
    },
    'offsetY': {
      'default': 180,
      'label': 'Afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand t.o.v. de bovenkant',
    },
    'circleSize': {
      'default': 200,
      'label': 'Radius circle',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Groote van de circle',
    },
    'marginLeft': {
      'default': 100,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 300,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 100,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 100,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'timings': {
    'templateAnimation': {
      'default': 1,
      'label': 'Template animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [[0.86]],
    'columnLimitMin': 1,
    'columnLimitMax': 1,
    'columnLabelNumber': 0,
    'rowLimitMin': 1,
    'rowLimitMax': 5,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'colorScheme','animationType'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': ['circleSize', 'circleColorScheme'],
    },
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': ['templateAnimation']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/test/video.params.ts